import React from 'react';

import Auth from 'modules/Auth';
import { PermissionsEnum } from 'consts/permissions';
import { FilterCreativeType } from 'components/common/FilterArea/Filters';
import AsyncSelect from 'lib/AsyncSelect';
import { SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { CodeNameModel } from 'components/common/types';
import { MotionType } from 'consts/motionType';
import { Advertiser, Brand } from 'components/common/types/Deal.types';

import { creativeTypes } from './AssignCreativeModal.types';
import { ContentSearchFiltersProps } from './ContentSearchFilters.type';

const ContentSearchFilters = ({
  filters,
  panelMotionType,
  advertiser,
  brand,
  onLoadAdvertisersLookupData,
  onLoadBrandLookupData,
  setFilters,
}: ContentSearchFiltersProps): React.ReactElement | null => {
  if (!Auth.hasPermission(PermissionsEnum.CONTENT_SEARCH)) return null;

  const onSelectAdvertiser: SelectHandler<Advertiser> = (_, value: Advertiser) => {
    setFilters((prevState) => ({ ...prevState, advertiser: value, brand: null }));
  };

  return (
    <>
      <AsyncSelect
        dataTestId="advertiser-input"
        name="advertiser"
        loadData={onLoadAdvertisersLookupData}
        selectedValue={filters.advertiser}
        placeholder="Advertiser"
        onSelect={onSelectAdvertiser}
        isDisabled={!!advertiser}
      />
      <AsyncSelect
        dataTestId="brand-input"
        name="brand"
        loadData={onLoadBrandLookupData}
        selectedValue={filters.brand}
        placeholder="Brand"
        onSelect={(_: string, value: Brand) => {
          setFilters((prevState) => ({ ...prevState, brand: value }));
        }}
        defaultOptions={filters.advertiser?.brands || []}
        isDisabled={!filters.advertiser || !!brand}
      />
      <FilterCreativeType
        options={creativeTypes}
        selectedValue={creativeTypes.find((creativeType) => creativeType.code === filters.creativeType)}
        onSelect={(_, value) => {
          setFilters((prevState) => ({ ...prevState, creativeType: (value as CodeNameModel).code }));
        }}
        isDisabled={panelMotionType === MotionType.STILL}
      />
    </>
  );
};

export default ContentSearchFilters;
